import compact from 'lodash/compact';
import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';

import { FileCategoryEnum, FileSchema } from '@/types/schema';

// TODO: @aryan02420 use these everywhere in the codebase
class FileEntity {
  static isFileTypeStack(file: Pick<FileSchema, 'category'>): boolean {
    return file.category === FileCategoryEnum.Folder;
  }
  static isFileTypeList(file: Pick<FileSchema, 'category' | 'projectStatus'>): boolean {
    // FIXME: @aryan02420 use FileSubCategoryEnum
    return file.category === FileCategoryEnum.File && isNil(file.projectStatus);
  }
  static isFileTypeProject(file: Pick<FileSchema, 'category' | 'projectStatus'>): boolean {
    // FIXME: @aryan02420 use FileSubCategoryEnum
    return file.category === FileCategoryEnum.File && !isNil(file.projectStatus);
  }
  static isSystemGenerated(file: Pick<FileSchema, 'systemGenerated'>): boolean {
    return file.systemGenerated === true;
  }
  static fileHasStages(file: { stages?: Array<unknown> | null }): boolean {
    return !isEmpty(compact(file.stages));
  }
  /**
   * True if the file is a project and has stages, false otherwise.
   */
  static shouldShowStages(
    file: Pick<FileSchema, 'category' | 'projectStatus'> & { stages?: Array<unknown> | null },
  ): boolean {
    return FileEntity.isFileTypeProject(file) && FileEntity.fileHasStages(file);
  }
}

export default FileEntity;
